export default __webpack_public_path__ + "assets/images/9a4a47278058ea07276ff1fdff289f2b.svg";